(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["art-media-comparison"] && !Shopify.designMode) return;
  try {
    
  const prepareStoryVideo = (section) => {
    const video = section.querySelector('video');
    if (!video || video.dataset.playbackReady) return;
    video.dataset.playbackReady = 'true';
    const button = section.querySelector('.art-story__play');
    let pending = false;
    const play = () => {
      if (document.hidden || !video.paused || pending) return;
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      pending = true;
      video.play().catch(() => { button.hidden = false; }).finally(() => { pending = false; });
    };
    video.addEventListener('playing', () => { button.hidden = true; });
    video.addEventListener('pause', () => { button.hidden = false; });
    video.addEventListener('canplay', play);
    button.addEventListener('click', play);
    document.addEventListener('visibilitychange', play);
    window.addEventListener('pageshow', play);
    document.addEventListener('pointerdown', play, {once: true, passive: true});
    play();
  };
  document.querySelectorAll('.art-story').forEach(prepareStoryVideo);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('.art-story').forEach(prepareStoryVideo);
  });

  } catch(e) { console.error(e); }
})();
})();
